export default "__VITE_ASSET__GxTotTKc__"